<script lang="ts">
import { ComplaintPaging, LANG_EN, REQUEST_STATUS, REQUEST_STATUS_OPTIONS, REQUEST_TYPE } from "@/app/const";
import { complaintStatusBreadcrumb } from "@/components/utils";
import { ComplaintInfo } from "@/interface/Complaint.interface";
import { complaintService } from "@/services/serviceProvider";
import { useSharedDataStore } from "@/store/app";
import { useRouter } from "vue-router";
export default {
  setup() {
    const router = useRouter();
    const store = useSharedDataStore();

    return {
      router, store
    };
  },
  components: {},
  props: {
    dialog: {
      type: Boolean
    },
    itemId: Number
  },
  data() {
    return {
      complaints: [] as any[],
      statusOptions: REQUEST_STATUS_OPTIONS,
      filter: {
        subTopic: undefined as string | undefined,
        status: undefined as string | undefined,
        complaintNo: undefined as string | undefined,
      },
      loading: false,
      paging: { ...ComplaintPaging },
      breadcrumb: [...complaintStatusBreadcrumb],
      lang: this.$i18n.locale,
    };
  },
  mounted() {
    this.store.setMyData({ reloadDoc: false });
  },
  created() {
    this.loadItems();
  },
  watch: {
    '$i18n.locale': function (newVal, oldVal) {
      this.lang = newVal;
    }
  },
  computed: {
    headers() {
      return [
        { title: this.$t('t-complaint-request-no'), key: 'complaintNo', width: '13%' },
        { title: this.$t('t-complaint-subject'), key: 'mainTopic', width: '20%' },
        { title: this.$t('t-complaints'), key: 'subTopic', width: '20%' },
        { title: this.$t('t-complaint-submitted-date'), key: 'submittedDate', width: '10%' },
        { title: this.$t('t-complaint-action-date'), key: 'updatedDate', width: '10%' },
        { title: this.$t('t-status'), key: 'status', width: '13%' },
        { title: '', key: 'actions', sortable: false, width: '2%' },
      ];
    },
    paginatedItems() {
      const start = (this.paging.page - 1) * this.paging.itemsPerPage;
      const end = this.paging.page * this.paging.itemsPerPage;
      return this.filteredComplaints.slice(start, end);
    },
    pageCount() {
      return Math.ceil(this.filteredComplaints.length / this.paging.itemsPerPage);
    },
    haveFilter() {
      return this.filter.subTopic || this.filter.status || this.filter.complaintNo;
    },
    filteredComplaints() {
      return this.complaints;
    },
  },
  methods: {
    async loadItems() {
      try {
        let res;
        if (!this.haveFilter) {
          res = await complaintService.getAllUserRequests();
        } else {
          res = await complaintService.getUserRequestsWithConditions(this.filter);
        }
        if (res && res.status == 200) {
          // let data = res.data;
          // let draft = data.find(o => o.status === REQUEST_STATUS.DRAFT);
          // let inProg = data.find(o => o.status === REQUEST_STATUS.IN_PROGRESS && o.subTopicTh != 'อื่นๆ');
          // let active = data.find(o => o.status === REQUEST_STATUS.ACTIVE);
          // let req_doc = data.find(o => o.status === REQUEST_STATUS.REQUEST_DOC && o.subTopicTh != 'อื่นๆ');
          // let cancel = data.find(o => o.status === REQUEST_STATUS.CANCELLED);
          // let end = data.find(o => o.status === REQUEST_STATUS.END);
          // this.complaints = [draft, active, inProg, req_doc, cancel, end];
          this.complaints = res.data;
          if (this.breadcrumb[0])
            this.breadcrumb[0].total = this.complaints.length;
        }
      } catch (e) {

      }
    },
    openRequest(requestNo: string, requestType: string) {
      if (requestType === REQUEST_TYPE.OCPB) {
        this.router.push({
          path: `/complaint-ocpb/${requestNo}`
        })
      } else if (requestType === REQUEST_TYPE.OPM) {
        this.router.push({
          path: `/complaint-opm/${requestNo}`
        })
      } else {
        this.router.push({
          path: `/complaint/${requestNo}`
        })
      }
    },
    canEdit(status: string) {
      return status === REQUEST_STATUS.DRAFT;
    },
    mainTopicName(item: ComplaintInfo) {
      return this.lang === LANG_EN ? item.mainTopicEn : item.mainTopicTh;
    },
    subTopicName(item: ComplaintInfo) {
      return this.lang === LANG_EN ? item.subTopicEn : item.subTopicTh;
    },
    dateString(date: Date | undefined) {
      return complaintService.dateTimeString(date);
    },
    showSubmittedDate(complaint: ComplaintInfo) {
      return complaint.status !== REQUEST_STATUS.DRAFT
        && complaint.status !== REQUEST_STATUS.CANCELLED
    },
    showActiveDate(complaint: ComplaintInfo) {
      return complaint.status !== REQUEST_STATUS.DRAFT
        && complaint.status !== REQUEST_STATUS.CANCELLED
    },
  },
};
</script>
<template>
  <v-card class="app-card d-flex align-center">
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="10" lg="11">
          <v-row>
            <v-col cols="12" sm="4" lg="3">
              <div class="text-label">{{ $t('t-complaint-request-no') }}</div>
              <v-text-field v-model.trim="filter.complaintNo" class="hide-float-label" variant="outlined"
                hide-details="auto" density="comfortable" :label="$t('t-please-input')" clearable></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" lg="6">
              <div class="text-label">{{ $t('t-complaints') }}</div>
              <v-text-field v-model.trim="filter.subTopic" class="hide-float-label" variant="outlined"
                hide-details="auto" density="comfortable" :label="$t('t-please-input')" clearable></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" lg="3">
              <div class="text-label">{{ $t('t-status') }}</div>
              <v-select v-model="filter.status" class="hide-float-label" variant="outlined"
                :label="$t('t-please-select')" hide-details="auto" :items="statusOptions" item-value="value"
                item-title="label" density="comfortable" clearable>
                <template v-slot:item="{ props, item }">
                  <div class="select-chips-color">
                    <v-list-item v-bind="props" height="2000">
                      <template v-slot:title="{ title }">
                        <v-chip class="app-chip" :class="item.raw.value" :color="item.raw.color">
                          {{ $t(`t-${item.raw.label}`) }}
                        </v-chip>
                      </template>
                    </v-list-item>
                  </div>
                </template>
                <template v-slot:selection="{ item }">
                  <div class="select-chips-color">
                    <v-chip class="app-chip" :class="item.raw.value" :color="item.raw.color">
                      {{ $t(`t-${item.raw.label}`) }}
                    </v-chip>
                  </div>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="2" lg="1" class="d-flex align-end">
          <v-btn class="btn-search" variant="flat" color="primary" size="large" append-icon="mdi-magnify"
            @click="paging.page = 1; loadItems()" block>
            {{ $t('t-search') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
  <v-card class="app-card">
    <v-card-text>
      <v-row class="mb-2">
        <v-col cols="12" class="header d-flex align-center pl-4">
          <h1>{{ $t('t-list-all') }}</h1>
        </v-col>
      </v-row>
      <v-data-table :headers="headers" :items="paginatedItems" :loading="loading" :items-per-page="paging.itemsPerPage"
        @update:options="loadItems" density="comfortable" class="flight-information-table"
        :no-data-text="$t('t-no-data-available')">
        <template v-slot:headers="{ columns, isSorted, getSortIcon, toggleSort }">
          <tr>
            <template v-for="column in columns" :key="column.key">
              <th class="font-weight-bold text-start">
                <span>{{ column.title }}</span>
              </th>
            </template>
          </tr>
        </template>
        <template #[`item.mainTopic`]="{ item }">
          {{ mainTopicName(item) }}
        </template>
        <template #[`item.subTopic`]="{ item }">
          {{ subTopicName(item) }}
        </template>
        <template #[`item.submittedDate`]="{ item }">
          <div v-if="showSubmittedDate(item)" class="w-100">
            {{ dateString(item.submittedDate) }}
          </div>
          <div v-else>-</div>
        </template>
        <template #[`item.updatedDate`]="{ item }">
          <div v-if="showActiveDate(item)" class="w-100">
            {{ dateString(item.updatedDate) }}
          </div>
          <div v-else>-</div>
        </template>
        <template #[`item.status`]="{ item }">
          <div class="d-inline-block mr-1">
            <v-chip class="app-chip" :class="statusOptions.find(o => o.value === item.status)?.value"
              :color="statusOptions.find(o => o.value === item.status)?.color">
              <span v-if="statusOptions.find(o => o.value === item.status)?.value !== 'end'">
                {{$t(`t-${statusOptions.find(o => o.value === item.status)?.label}`)}}
              </span>
              <span v-else>
                <span>
                  {{$t(`t-${statusOptions.find(o => o.value === item.status)?.label}`)}}
                </span>
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="actions d-flex align-center">
            <v-btn v-if="canEdit(item.status)" variant="text" color="primary"
              @click="openRequest(item.requestNo, item.requestType)">
              <v-icon icon="mdi mdi-pencil" class="mr-1"></v-icon>
              <span>{{ $t('t-edit') }}</span>
            </v-btn>
            <v-btn v-else variant="text" color="primary" @click="openRequest(item.requestNo, item.requestType)">
              <v-icon icon="mdi mdi-eye-outline" class="mr-1"></v-icon>
              <span>{{ $t('t-view') }}</span>
            </v-btn>
          </div>
        </template>
        <template v-slot:bottom>
          <v-pagination v-model="paging.page" :length="pageCount" density="comfortable" class="mr-3 mt-3">
            <template v-slot:prev>
              <v-btn v-if="filteredComplaints.length > 0" :disabled="paging.page <= 1" icon class="w-100 prev-btn mr-6"
                @click="paging.page -= 1; paging.page < 1 ? paging.page = 1 : paging.page">
                <v-icon class="mr-2">mdi-arrow-left</v-icon>
                <span>{{ $t('t-prev') }}</span>
              </v-btn>
            </template>
            <template v-slot:next>
              <div class="d-flex align-center justify-end w-100">
                <v-btn v-if="filteredComplaints.length > 0" :disabled="paging.page >= pageCount" icon class="next-btn"
                  @click="paging.page += 1; paging.page > pageCount ? paging.page = pageCount : paging.page">
                  <span class="mr-2">{{ $t('t-next') }}</span>
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
                <div class="bottom d-flex align-center justify-end w-100">
                  <span v-if="filteredComplaints.length > 0" class="slash mr-4">/</span>
                  <span class="mr-3">{{ $t('t-number-per-page') }}</span>
                  <v-select v-model="paging.itemsPerPage" class="hide-float-label mr-3" variant="outlined"
                    hide-details="auto" :items="paging.items" item-value="value" item-title="label"
                    density="comfortable"></v-select>
                  <span>{{ $t('t-table-role') }}</span>
                </div>
              </div>
            </template>
          </v-pagination>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
  <div class="space-for-desktop" style="height: 50px;"></div>
  <div class="space-for-mobile" style="display: none"></div>
</template>
